import { render, staticRenderFns } from "./VuesticIconFree.vue?vue&type=template&id=660bcdd1&"
import script from "./VuesticIconFree.vue?vue&type=script&lang=js&"
export * from "./VuesticIconFree.vue?vue&type=script&lang=js&"
import style0 from "./VuesticIconFree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticIconFree.vue"
export default component.exports